export type CollectedError = {
  parentKey: string;
  errorMessage: string;
};

const CollectErrors = (obj: { [key: string]: any }): CollectedError[] => {
  const errors: CollectedError[] = [];

  function searchErrors(value: any, parentKey = '') {
    if (Array.isArray(value)) {
      value.forEach((errorMessage) => {
        errors.push({ parentKey, errorMessage });
      });
    } else if (typeof value === 'object' && value !== null) {
      Object.keys(value).forEach((key) => {
        searchErrors(value[key], key);
      });
    }
  }

  searchErrors(obj);

  return errors;
};

export default CollectErrors;
